/**
 *
 * ListTitle
 *
 */

import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import Colors from 'utils/colors';
import ClassNames from 'classnames';

function ListTitle(props) {
  const { color, title, isMain } = props;
  let styles;
  if (color) {
    styles = theme => ({
      root: {
        ...theme.typography.h4,
        color,
      },
    });
  } else {
    styles = theme => ({
      root: {
        ...theme.typography.h4,
      },
      inverseText: {
        color: Colors.blue,
      },
    });
  }

  const MyListTitle = ({ classes, inverse, children }) => (
    <Typography
      align="left"
      variant={isMain ? 'h1' : 'h2'}
      color="textPrimary"
      className={ClassNames(
        classes.root,
        inverse ? classes.inverseText : undefined,
      )}
    >
      {children}
    </Typography>
  );

  MyListTitle.propTypes = {
    classes: PropTypes.object,
    inverse: PropTypes.bool,
    children: PropTypes.node,
  };

  const Styled = withStyles(styles)(MyListTitle);
  return <Styled>{title}</Styled>;
}

ListTitle.propTypes = {
  title: PropTypes.string,
  color: PropTypes.string,
  isMain: PropTypes.bool,
};

ListTitle.defaultProps = {
  isMain: false,
};

export default ListTitle;
